import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { AmplitudeEvents } from 'features/Yucollect/utils/constant';
import { getUserDetails } from 'features/Yucollect/utils/util';
import { useAppSelector } from 'utils/hooks/useAppSelector';

import useAmplitude from './useAmplitude';

const usePageTracking = () => {
  const location = useLocation();
  const { trackEvent } = useAmplitude();
  const userEntities = useAppSelector((state) => state.userEntities);

  useEffect(() => {
    const pageName = location.pathname;

    trackEvent(AmplitudeEvents.PAGE_VIEW_EVENT, {
      page: pageName,
      ...getUserDetails(userEntities),
    });
  }, [location]);
};

export default usePageTracking;
